import { Button, Grid } from '@material-ui/core'
import ArrowBackIos from '@material-ui/icons/ArrowBackIos'
import * as React from 'react'
import ReactFileReader from 'react-file-reader'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import cameraImage from '../../assets/img/camera.png'
import EducatorForm from './educatorForm'
import PatientForm from './patientForm'

import { Header, PageTitle } from 'components'

export interface INativeProps {
  typeOfForm: string
  changeTypeOfForm: any
  isValidForm: boolean
  onSubmit: any
  image: any
  handleFiles: any
  isPhotoValid: boolean
  onChangeMaskedInput: any
  onChangeRadio: any
  loading: boolean
}

export interface IProps extends INativeProps, RouteComponentProps {}

class Content extends React.PureComponent<IProps> {
  renderPatientDetails = () => (
    <div>
      <PageTitle text="Patient Details" />
      <PatientForm
        onChangeMaskedInput={this.props.onChangeMaskedInput}
        onChangeRadio={this.props.onChangeRadio}
      />
    </div>
  )

  renderAvatarForm = () => {
    const { handleFiles, image } = this.props
    return (
      <>
        <div className="photo-section-wrapper">
          <div className="add-photo-title"> Add patient profile picture</div>
          <div className="photo-section">
            <ReactFileReader handleFiles={handleFiles} base64={true}>
              <React.Fragment>
                <div className="logo">
                  <div className="wrapper">
                    <img
                      src={image ? image : cameraImage}
                      className={`camera-image ${image ? 'active' : undefined}`}
                    />
                  </div>
                </div>
                {image ? undefined : <div className="add-button" />}
              </React.Fragment>
            </ReactFileReader>
          </div>
        </div>
      </>
    )
  }

  renderEducatorDetails = () => (
    <div>
      <PageTitle text="Educator Details" />
      <EducatorForm onChangeMaskedInput={this.props.onChangeMaskedInput} />
    </div>
  )

  goBackAction = () => {
    const { typeOfForm, changeTypeOfForm } = this.props
    if (typeOfForm === 'educator') {
      changeTypeOfForm('addPatientPhoto')
    } else if (typeOfForm === 'addPatientPhoto') {
      changeTypeOfForm('patient')
    } else {
      this.props.history.goBack()
    }
  }

  render() {
    const {
      typeOfForm,
      changeTypeOfForm,
      isValidForm,
      isPhotoValid,
      onSubmit,
      loading
    } = this.props

    return (
      <Grid
        container={true}
        direction="column"
        justify="space-between"
        alignItems="center"
        className="add-patient-page page-min-content"
      >
        {typeOfForm !== 'addPatientPhoto' ? (
          <Header
            title="Add Patient"
            type="color"
            goBackAction={this.goBackAction}
          />
        ) : null}
        {typeOfForm === 'addPatientPhoto' ? (
          <div className="skip-btn-wrapper">
            <div style={{ cursor: 'pointer' }} onClick={this.goBackAction}>
              <ArrowBackIos />
            </div>
            <div
              className="skip-btn"
              onClick={() => changeTypeOfForm('educator')}
            >
              Skip
            </div>
          </div>
        ) : null}
        <div className="add-patient-page-content page-content">
          {typeOfForm === 'patient'
            ? this.renderPatientDetails()
            : typeOfForm === 'addPatientPhoto'
            ? this.renderAvatarForm()
            : this.renderEducatorDetails()}
        </div>
        <div className="next-button-wrap">
          <Button
            className={`black-btn next-button ${
              typeOfForm === 'addPatientPhoto' && !isPhotoValid
                ? 'disabled'
                : null || !isValidForm
                ? 'disabled'
                : null
            }`}
            color="primary"
            onClick={() => {
              if (loading) {
                return
              }

              if (typeOfForm === 'patient') {
                changeTypeOfForm('addPatientPhoto')
              } else if (typeOfForm === 'addPatientPhoto') {
                changeTypeOfForm('educator')
              } else if (typeOfForm === 'educator') {
                onSubmit()
              }
            }}
          >
            {typeOfForm === 'patient'
              ? 'Next'
              : typeOfForm === 'addPatientPhoto'
              ? 'Next'
              : 'Confirm'}
          </Button>
        </div>
      </Grid>
    )
  }
}

const WithRouter = withRouter(Content)

export default (props: INativeProps) => <WithRouter {...props} />



// WEBPACK FOOTER //
// ./src/pages/AddPatient/content.tsx